import { If } from "components";
import isEmpty from "lodash/isEmpty";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";
import { Modal } from "ui";

import {
  useCreateCategory,
  useGetCategoryById,
  useUpdateCategory
} from "../../../apis";
import { CategoryModalProps } from "../../components.types";
import { CategoryForm, CategoryFormData } from "../../forms";
import { ModalFooter } from "../atoms";

import styles from "./MainCategoryModal.module.scss";

const MAIN_CATEGORY_FORM_ID = "main-category-form-id";

const MainCategoryModal = ({
  isOpen,
  category,
  renderDeleteCategory,
  refetchCategories,
  onClose
}: CategoryModalProps) => {
  const { t } = useTranslation();
  const isUpdateCategory = !isEmpty(category);

  const onSuccessActionCategory = () => {
    refetchCategories();
    onClose();
  };

  const { category: editableCategory, isFetching: isEditableCategoryFetching } =
    useGetCategoryById(category?.id);

  const { isLoading: isLoadingCreateCategory, mutate: mutateCreateCategory } =
    useCreateCategory({
      onSuccess: onSuccessActionCategory
    });

  const { isLoading: isLoadingUpdateCategory, mutate: mutateUpdateCategory } =
    useUpdateCategory({
      onSuccess: onSuccessActionCategory
    });

  const onSubmit = (formData: CategoryFormData) => {
    const { image, name } = formData;

    const body = {
      imageId: image?.id ?? null,
      name
    };

    return isUpdateCategory
      ? mutateUpdateCategory({
          id: category.id,
          ...body
        })
      : mutateCreateCategory(body);
  };

  return (
    <Modal
      formId={MAIN_CATEGORY_FORM_ID}
      className={styles["main-category-modal"]}
      isOpen={isOpen}
      title={t(`${isUpdateCategory ? "Edit" : "New"} Category`)}
      isLoading={isLoadingCreateCategory || isLoadingUpdateCategory}
      okText={isUpdateCategory ? t("Save") : t("Create")}
      extraFooter={ModalFooter({
        renderDeleteCategory,
        isEditableCategoryFetching,
        editableCategory
      })}
      onClose={onClose}
    >
      <If condition={isUpdateCategory && !editableCategory}>
        <div className={styles["main-category-modal_loader"]}>
          <ClipLoader size={30} color="#fb3973" />
        </div>
      </If>

      <If condition={!isUpdateCategory || editableCategory}>
        <CategoryForm
          formId={MAIN_CATEGORY_FORM_ID}
          category={editableCategory ?? null}
          isMainCategory
          onSubmit={onSubmit}
        />
      </If>
    </Modal>
  );
};

export default MainCategoryModal;
